import { put } from 'redux-saga/effects';
import { apiPost } from 'shared/api';
import * as actions from 'store/actions';

export function* fetchGroupPostsListSaga(action) {
  yield put(actions.fetchGroupPostsListStart());
  try {
    const data = { GroupId: action.GroupId };
    if (action.Page) {
      data.Page = action.Page;
    }
    if (action.PageSize) {
      data.PageSize = action.PageSize;
    }
    if (action.RoomId) {
      data.RoomId = action.RoomId;
    }
    if (action.Tag) {
      data.Tag = action.Tag;
    }
    const response = yield apiPost('v2_userGroupView', data);
    yield put(
      actions.fetchGroupPostsListSuccess(
        action.GroupId,
        response.data.payload.Posts,
        response.data.payload.PostCount,
        response.data.payload.PostLimit,
        action.Page,
        action.Tag,
      ),
    );
  } catch (error) {
    yield put(actions.fetchGroupPostsListFailed(error.response.data.error_message));
  }
}

export default {};
